<template>
    <div id="index">

        <div class="swiper-container_not bigSwiper">
            <div class="swiper-wrapper_not">
                <div class="swiper-slide_not slide1" data-hash="slide1">
                    <!--<my-header></my-header>-->
                    <!--<img class="bg1" src="../assets/images/index/bg1.jpg"/>-->
                    <!--<img class="text" src="../assets/images/index/text.png"/>-->
                    <div id="login" @keyup.enter="onSubmit">
                        <div class="top clearfix">
                            <img  src="../assets/images/login/logo.png" style="height: 45px;"/>
                            <div class="text11">智慧招采平台</div>
                        </div>
                        <div class="middle">
                            <div class="login_box">
                                <!-- <div class="login_text">建立合作共赢伙伴关系打造公开透明工作方式</div> -->
                                <el-form ref="form" :model="form" :rules="rules">
                                    <el-form-item prop="loginName">
                                        <el-input v-model="form.loginName" placeholder="用户名">
                                            <i slot="prefix" class="iconfont iconzhanghao"></i>
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item prop="fpassword">
                                        <el-input v-model="form.fpassword" placeholder="密码" type="password">
                                            <i slot="prefix" class="iconfont iconmima"></i>
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-checkbox v-model="checked">记住密码</el-checkbox>
                                        <span class="zc" @click="goUrl()">注册</span>
                                        <span class="zc" @click="forgetPWD()" style="margin-right: 10px;">忘记密码</span>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button class="submit" @click="onSubmit">登录</el-button>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </div>
                        <div class="bottom">
                            <el-row>
                                <el-col :span="6" class="border_r">
                                    <div class="type">招标公告</div>
                                </el-col>
                                <el-col :span="6" class="border_r">
                                    <div class="type">中标公告</div>
                                </el-col>
                                <el-col :span="6" class="border_r">
                                    <div class="type point" @click="help">帮助服务</div>
                                </el-col>
                                <el-col :span="6" class="border_r">
                                    <!-- <div class="ts_box"> -->
                                        <div class="type">招采公众号</div>
                                        <!-- <div>fwsj@cre-hopson.com</div>
                                        <div></div> -->
                                        <img class="ewm" src="../assets/images/login/gongzhonghao.jpg" alt="">
                                        <!-- <div style="height:30px"></div> -->

                                    <!-- </div> -->
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                </div>
                <div class="swiper-slide_not slide2" data-hash="slide2" >
                    <section style="margin-top:2%;">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <h3 class="title_1">
                                    招标公告
                                    <span class="eng">Bidding Announcement</span>
                                    <span @click="toInviteList" class="view">查看更多</span>
                                </h3>
                                <div class="box1">
                                    <el-table :data="lstTenderBidMessageResponseVO" style="width: 100%" height="100%"
                                              :show-header="false">
                                        <el-table-column>
                                            <template slot-scope="scope">
                                                <div class="left">
                                                    <div class="name ellipsis" style="cursor:pointer;" @click="toDetail(scope.row)">{{scope.row.announcementName}}</div>
                                                    <!-- <div class="ellipsis">招标公司：{{scope.row.msgTitle}}</div>
                                                    <div class="ellipsis">招标项目：{{scope.row.msgTitle}}</div> -->
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column :width="130">
                                            <template slot-scope="scope">
                                                <div>
                                                    <!-- <div class="date">2020/03/26 11:10:00 截止 </div> -->
                                                    <div>{{scope.row.categoryName}}</div>
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column :width="140" align="center">
                                            <template slot-scope="scope">
                                                <div style="font-size: 14px;">
                                                    {{$root.getMyDate(scope.row.createDate,2)}}发布
                                                </div>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>

                            </el-col>
                            <el-col :span="12">
                                <h3 class="title_1">
                                    中标公告
                                    <span class="eng">Successful Bid</span>
                                    <span @click="toWinList" class="view">查看更多</span>
                                </h3>
                                <div class="box1">
                                    <el-table :data="lstWinBidMessageResponseVO" style="width: 100%" height="100%"
                                              :show-header="false">
                                        <el-table-column prop="msgTitle">
                                            <template slot-scope="scope">
                                                <div class="left">
                                                    <div class="name ellipsis">{{scope.row.msgTitle}}</div>
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column :width="190">
                                            <template slot-scope="scope">
                                                <div class="left">
                                                    <div class="name ellipsis">{{scope.row.msgContent}}</div>
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column :width="140" align="center">
                                            <template slot-scope="scope">
                                                <div style="font-size: 14px;">
                                                    {{$root.getMyDate(scope.row.createDate,2)}}发布
                                                </div>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </el-col>
                        </el-row>
                    </section>
                    <div class="footer">
                        <div class="box">
                            <el-row :gutter="20">
                                <el-col :span="8">
                                    <el-col :span="12" class="left">
                                        <div>帮助服务</div>
                                        <div style="margin-top:5px;">Help Center</div>
                                    </el-col>
                                    <el-col :span="12" class="right">
                                        <el-popover
                                            placement="top-start"
                                            title=""
                                            width="175"
                                            trigger="hover">
                                            <div class="" style="font-size:12px;">
                                                <p>华北区&nbsp;&nbsp;武<span class="text-span-right"></span>锋&nbsp;18911257895</p>
                                                <p>华中区&nbsp;&nbsp;廖珍珍&nbsp;13661549680</p>
                                                <p>华南区&nbsp;&nbsp;陈洪奔&nbsp;13380095530</p>
                                                <p>成都区&nbsp;&nbsp;张丽君&nbsp;18602821752</p>
                                            </div>
                                            <div slot="reference" style="cursor:pointer;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;">联系电话</div>
                                            <!-- <el-button slot="reference">hover 激活</el-button> -->
                                        </el-popover>
                                        
                                        <div>周一到周五：08:30 ~ 17:00</div>
                                    </el-col>
                                </el-col>
                                <el-col :span="8">
                                    <el-col :span="12" class="left">
                                        <div>联系地址</div>
                                        <!-- <div style="margin-top:5px;">Contact Us</div> -->
                                    </el-col>
                                    <el-col :span="12" class="right">
                                        <div>邮编：200442</div>
                                        <div>地址：北京市朝阳区合生汇</div>
                                        <!-- <div>邮箱：fwsj@cre-hopson.com</div> -->
                                    </el-col>
                                </el-col>
                              <el-col :span="8">
                                    <el-col :span="12" class="left">
                                        <div>投诉举报</div>
                                        <div>fwsj@cre-hopson.com</div>
                                    </el-col>
                                    <el-col :span="12" class="right" height="81px">
                                        <img class="ewm" src="../assets/images/login/erweima.jpg" alt="">
                                    </el-col>
                                </el-col>
                            </el-row>
                            <div style="text-align: center;color: #9B9B9B;font-size: 12px;margin-top: 10px">合商科技有限公司 版权所有粤ICP备19055132号</div>
                        </div>
                    </div>
                </div>

            </div>
            <!--<div class="swiper-pagination"></div>-->
            <!--<div class="swiper-button-next bigSwiperNext"></div>-->
        </div>
    </div>

</template>
<script type="text/babel">
    import MyHeader from './common/Header'
    import MyFooter from './common/Footer'
    import Swiper from 'swiper'
    import util from '../util/index'
    import md5 from 'js-md5';

    export default {
        name: 'index',
        data(){
            return {
                hashVal: '',
                lstTenderBidMessageResponseVO: [],//招标公告
                lstWinBidMessageResponseVO: [],//中标公告
                form: {
                    loginName: "",
                    fpassword: "",
                },
                checked: false,
                rules:{
                    loginName: [
                        { required: true, message: '请输入账号', trigger: 'blur' },
                    ],
                    fpassword: [
                        { required: true, message: '请输入密码', trigger: 'blur' },
                    ],
                }
            }
        },
        components: {
            MyHeader,
            MyFooter
        },
        created(){
            let _this = this;
            this.$root.getHttp('v1/login/public/getRestIndex', function (res) {
                _this.lstTenderBidMessageResponseVO = res.data.data.sannouncementVOList || [];
                _this.lstWinBidMessageResponseVO = res.data.data.lstWinBidMessageResponseVO || [];
            })
        },
        mounted(){
            if(localStorage.getItem("remenberPassword")){
                this.checked = true;
                this.form.loginName = localStorage.getItem("loginName");
                this.form.fpassword = localStorage.getItem("loginPassword");
                this.checked = !!localStorage.getItem("remenberPassword");
            }

            var loginRightEl = document.getElementsByClassName('loginRight');
            if (loginRightEl.length) {
                loginRightEl[0].className = 'loginRight loginIndex'
            }
           /*  var bigSwiperNextEl = document.querySelector('.bigSwiperNext');
            var mySwiper = new Swiper(".bigSwiper", {
                direction: "vertical",
//                height: window.innerHeight,
                hashnav: true,//拖动会切换对应的hash值；
                keyboardControl: true,
//                autoHeight: true,
                pagination: '.swiper-pagination',
                paginationType: 'custom',//自定义分页器
                paginationClickable: true,//分页器可点击切换
//                bulletClass: 'swiper-pagination-bullet',
                paginationBulletRender: function (swiper, index, className) {
//                    return '<span class="swiper-pagination-bullet"></span>';
                },
                nextButton: '.bigSwiperNext',
                mousewheelControl: true,//鼠标滚动可以控制切换；
                observer: true,//window.resize，Swiper更新
                observeParents: true,
                onSlideChangeEnd: function (swiper) {
//                    console.log(swiper,swiper.activeIndex)
//                    if (swiper.activeIndex <= 3) {
//                        bigSwiperNextEl.style.display = 'block';
//                    } else {
//                        bigSwiperNextEl.style.display = 'none';
//                    }
                }
            });
            new Swiper(".smallSwiper", {
                loop: false,
                height: 240,
                nextButton: '.smallSwiperNext',
                prevButton: '.smallSwiperPrev',
            }); */
        },
        methods: {
            help(){
                window.open('#/guide')
            },
            forgetPWD(){
                this.$router.push('/changePwd?isForgetPage='+1);
            },
            goUrl(){
                this.$router.push('/register');
            },
            toInviteList(){//招标公告
                this.$root.activeIndex = 'invite';
                this.$router.push('/invite-list');
            },
            toWinList(){//中标公告
                this.$root.activeIndex = 'win';
                this.$router.push('/win-list');
            },
            toIndex(){
                this.$root.activeIndex = 'home';
                this.$router.push('/gateway/index');
            },
            toDetail(val){//到详情页。
//              console.log(id)
                this.$router.push('/invite-listDetail/'+val.id+'/'+val.acType);
            },
            onSubmit(){
                var _this = this;
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        _this.$root.postHttp('/v1/login/public/restLogin',{
                            "userName": _this.form.loginName,
                            "password": md5(_this.form.fpassword),
                        },(res)=>{
                            console.log(res)
                            _this.$root.isLogin = true;
//                                设置token，用来判断是否登录；
                            window.sessionStorage.setItem('token',res.headers.token);
                            window.sessionStorage.setItem('refresh_token',res.headers.refresh_token);
                            window.sessionStorage.setItem('loginId',res.data.data.suppliersId);
                            window.sessionStorage.setItem('companyName',res.data.data.companyName);
                            this.checkRemenber()
                            // debugger
                            if(!_this.$route.params.url){
                                _this.toIndex();
                            }else if(_this.$route.params.url == 'masterCenter'){
                                _this.$router.push('/master/center');
                            }else{
                                window.location.href = decodeURIComponent(_this.$route.params.url);
                            }

                            // _this.$root.activeIndex = 'home';
                        },()=>{

                        })
                    } else {
                        return false;
                    }
                });
            },
            //检查是否记住密码
            checkRemenber(){
                if (this.checked) {
                    localStorage.setItem("loginName", this.form.loginName)
                    localStorage.setItem("loginPassword", this.form.fpassword)
                    localStorage.setItem("remenberPassword", true)
                } else {
                    localStorage.removeItem("loginName")
                    localStorage.removeItem("loginPassword")
                    localStorage.removeItem("remenberPassword")
                }
            }
        }
    }
</script>
<style scoped lang="scss">
    @import "../assets/_var.scss";
    @import "../assets/swiper.min.css";

    html, body {
        height: 100%;
    }

    html {
        overflow: hidden;
    }

 .text11{
                float: left;
                padding-left: 17px;
                margin-left: 17px;
                line-height: 33px;
                margin-top: 6px;
                font-size: 24px;
                color: #666666;
                border-left: 1px solid #979797;
            }

    .swiper-container {
        width: 100%;
    }

    .bigSwiper {
        & > .swiper-wrapper {
            height: 100vh;
            swiper-slide {
                height: 100vh;
            }
        }
        & .swiper-pagination-bullet {
            width: 20px;
            height: 5px;
            border-radius: 0;
            opacity: .5;
            background: #ccc;
        }
        & .swiper-pagination-bullets .swiper-pagination-bullet {
            margin: 12px 0;
        }
        & .swiper-pagination-bullets .swiper-pagination-bullet-active {
            width: 27px;
            margin-left: -7px;
            background: #fff;
            opacity: .8;
        }

    }

    .bigSwiperNext {
        /*bottom: 10px;*/
        /*top: unset;*/
        top: 90%;
        left: 50%;
        width: 30px;
        height: 30px;
        margin: 0 0 0 -15px;
        background-size: contain;
        background-image: url('../assets/images/index/arrow.png');
        transform: scale(1);
        transition: 1s;
    }

    .bigSwiperNext:hover {
        transform: scale(1.1);
        background-image: url('../assets/images/index/arrtow2.png');
    }

    .slide1 {
        position: relative;
    }

    .bg1 {
        display: block;
        width: 100%;
        height: 100vh;
    }

    .text {
        width: 40%;
        height: auto;
        position: absolute;
        left: 50%;
        top: 27.5%;
        transform: translateX(-50%);
    }

    .ellipsis{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .slide2 {
        background: url('../assets/images/login/bg.jpg') no-repeat;
        background-size: 100% auto;
        position: relative;
        padding: 1px;
        margin-top: 6vh;
        section {
            margin: 6vh auto;
            box-sizing: border-box;
            padding: 20px;
            width: 1200px;
            height: 68vh;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0 0 25px rgba(0, 0, 0, .3);
        }
        .title_1 {
            font-weight: normal;
            margin: 10px 0 20px;
            overflow: hidden;
            font-size: 16px;
            text-align: left;
            border-bottom: 2px solid #0091FF;
            padding-bottom: 10px;
            .eng {
                color: #999999;
                font-size: 14px;
                margin-left: 10px;
            }
            .view {
                float: right;
                color: #0091FF;
                font-size: 14px;
                cursor: pointer;
            }
        }
        .box1 {
            height: calc(68vh - 120px);
            .left {
                .name{
                    font-size: 14px;
                    color: #333333;
                    margin-bottom: 7px;

                }
                div{
                    font-size: 12px;
                    color: #999999;
                }
            }
            .middle{
                font-size: 12px;
                div{
                    text-align: right;
                    color: #333333;
                }
                .date{
                    font-weight: bold;
                }
            }
            .right{
                font-size: 14px;
                font-weight: bold;
            }
            .blod{
                font-size: 14px;
                font-weight: bold;
            }
        }


        .footer{
            background: #002247;
            position: absolute;
            // bottom: -145px;
            bottom: -125px;
            width: 100%;
            height: 120px;
            left: 0;
            color: #ffffff;
            font-size: 12px;
            padding-top: 15px;
            padding-bottom: 10px;
            .box{
                width: 1200px;
                margin: 0 auto;
            }
            .left{
                text-align: right;
            }
            .right{
                text-align: left;
                div{
                    margin-bottom: 5px;
                }
            }
            .ewm{
                width: 80px;
                height: 80px;
            }
        }
    }


    .slide2 .el-col {
        height: 75px;
    }


    .slide3 {
        position: relative;
        /*background: url('../assets/images/index/bg3.png') no-repeat 0 0/100% 100%;*/
        .bg3 {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
        }
        & section {
            position: relative;
            margin: 130px auto;
            box-sizing: border-box;
            padding: 30px 50px;
            width: 800px;
            height: 414px;
            background: rgba(255, 255, 255, .85);
            box-shadow: 0 0 15px rgba(0, 0, 0, .2);
            & li {
                padding-left: 30px;
                background: url('../assets/images/index/listIcon.png') no-repeat 0 center/15px 15px;
                text-align: left;
                overflow: hidden;
                font-size: 14px;
                line-height: 35px;
                cursor: pointer;
                & p {
                    float: left;
                }
                & p:hover {
                    color: $--primary-color;
                    text-decoration: underline;
                }
                .overflowT {
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    max-width: 500px;
                }
                & strong {
                    float: right;
                    color: $--text-color-lighter;
                    font-weight: normal;
                }
            }
            & .more {
                position: absolute;
                right: -35px;
                bottom: 30px;
                width: 122px;
                height: 32px;
                opacity: 1;
                transition: .3s;
                background: url('../assets/images/index/btnBg.png') no-repeat 0 0/contain;
                color: #fff;
                text-align: center;
                font-size: 12px;
                line-height: 32px;
                &::after {
                    content: '';
                    display: inline-block;
                    vertical-align: middle;
                    margin-left: 10px;
                    width: 12px;
                    height: 12px;
                    background: url('../assets/images/index/more2.png') no-repeat 0 0/contain;
                }
            }
        }
    }

    .slide4 {
        position: relative;
        & .main-container {
            margin-top: 100px;
            height: 302px;
            & img {
                display: block;
                margin: 0 auto;
                height: 42px;
            }
            & .smallSwiper {
                margin: 20px auto 0;
                width: 1000px;

                & .el-col {
                    height: 80px;
                    overflow: hidden;
                    text-align: center;
                    cursor: pointer;
                    & img {
                        width: 130px;
                        height: 70px;
                    }
                }
            }
            & .swiper-button-prev {
                width: 44px;
                background: url('../assets/images/index/Arrow_r.png') no-repeat 0 0/44px 44px;
            }
            & .swiper-button-next {
                width: 44px;
                background: url('../assets/images/index/Arrow_l.png') no-repeat 0 0/44px 44px;
            }
            .smallSwiperPrev,
            .smallSwiperNext {
                opacity: .8;
                transform: scale(1);
                transition: .3s;
            }
            .smallSwiperPrev:hover,
            .smallSwiperNext:hover {
                opacity: 1;
                transform: scale(1.1);
            }
        }
        /*  .foot-bg {
              position: absolute;
              left: 0;
              bottom: 0;
              width: 100%;
          }*/
    }

    #index {
        .view {
            cursor: pointer;
        }
        .view:hover {
            color: $--text-color;
        }
        .more:hover {
            opacity: .8;
            color: #fff;
        }
        .none {
            margin: 55px 0 70px;
            font-size: 16px;
            line-height: 40px;
            color: $--text-color-lighter;
            border: none;
        }
    }

    .head-top .loginIndex {
        border-bottom: 1px solid #fff;
        p {
            color: #fff;
            .backIndex {
                background: url('../assets/images/masterCenter/topBar/icon_01.png') no-repeat 10px center;
            }
            .helpT {
                background: url('../assets/images/masterCenter/topBar/icon_02.png') no-repeat 10px center;
            }
            .wechatT {
                background: url('../assets/images/masterCenter/topBar/icon_03.png') no-repeat 10px center;
            }
            .loginOut {
                background: url('../assets/images/masterCenter/topBar/icon_04.png') no-repeat 10px center;
            }
            .line {
                background: #fff;
            }
        }
    }

    #login {
        .top {
            padding: 20px 0;
            width: 310px;
            margin: 0 auto;
            img {
                float: left;
            }
            .text {
                float: left;
                padding-left: 17px;
                margin-left: 17px;
                line-height: 33px;
                margin-top: 6px;
                font-size: 20px;
                color: #666666;
                border-left: 1px solid #979797;
            }
        }
        .middle {
            height: calc(100vh - 208px);
            background: url("../assets/images/login/bg.jpg") 50% 50%;
            position: relative;
            background-size: 100% 100%;

            .login_box {
                .login_text {
                    color: #ffffff;
                    font-size: 20px;
                    width: 350px;
                    text-align: left;
                    letter-spacing: 7px;
                    margin-bottom: 20px;
                }
                padding: 30px;
                padding-top: 50px;
                width: 350px;
                position: absolute;
                top:6%;
                right: 10%;
                background: rgba($color: #fff, $alpha: 0.2);
                box-shadow: 0px 3px 15px 0px rgba(56,64,73,0.09);

                text-align: left;
                .zc {
                    color: #ffffff;
                    float: right;
                    cursor: pointer;
                }
                .el-input__inner {
                    font-size: 14px;
                    color: #494F56;
                    height: 50px;
                    line-height: 50px;
                    border-radius: 0;
                }
                .el-input__prefix {
                    top: 4px;
                }
                .iconfont {
                    color: #494F56;
                    font-size: 18px;
                    font-weight: 600;
                }
                .el-checkbox__inner {
                    background-color: transparent;
                    border-radius: 0;
                    border: 1px solid #ffffff;
                }
                .el-checkbox, .el-checkbox__input.is-checked + .el-checkbox__label {
                    color: #ffffff !important;
                }
                .submit {
                    display: block;
                    background-color: #003570;
                    width: 100%;
                    height: 50px;
                    color: #ffffff;
                    font-size: 15px;
                    border: none;
                }
                ::-webkit-input-placeholder { /* WebKit, Blink, Edge */
                    color: #494F56;
                }
                :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
                    color: #494F56;
                }
                ::-moz-placeholder { /* Mozilla Firefox 19+ */
                    color: #494F56;
                }
                :-ms-input-placeholder { /* Internet Explorer 10-11 */
                    color: #494F56;
                }
            }
        }
        .bottom {
            width: 1250px;
            margin: 0 auto;
            text-align: center;
            padding-top: 50px;
            .point{
                cursor: pointer;
            }
            .type {
                font-size: 20px;
                position: relative;
                &:after {
                    position: absolute;
                    border-bottom: 1px dashed #979797;;
                    width: 20px;
                    content: '';
                    left: calc(100% - 10px);
                    top: 50%;
                }
            }
            .border_r {
                border-right: 1px dashed #979797;
                height: 50px;
                line-height: 50px;
                .ewm {
                        position: absolute;
                        right: 0;
                        top: -20%;
                        width: 80px;
                        height: 80px;
                }
            }
            .ts_box {
                text-align: left;
                padding-left: 20%;
                position: relative;
                font-size: 14px;
                .name {
                    font-size: 20px;
                }
                div {
                    margin-bottom: 10px;
                }
                .ewm {
                    position: absolute;
                    right: 0;
                    top: 10%;
                    width: 80px;
                    height: 80px;
                }
            }
            .fr {
                float: right;
                a {
                    margin-left: 70px;
                    text-decoration: underline;
                    color: #666666;
                    cursor: pointer;
                }
            }
        }
    }
    .text-span-right{
        margin-right: 13px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/Index.vue